import React from 'react';
import { Lock, Zap, ShieldCheck } from 'lucide-react';
export function FinalCTA() {
  const scrollToOffer = () => {
    document.getElementById('offer-details')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-ink px-5 py-16 md:py-28 text-center" data-id="element-84" data-mp="c7k4huqyqhna">
      <div className="max-w-3xl mx-auto" data-id="element-85" data-mp="84nuutjehvvh">
        <p className="text-[0.7rem] md:text-xs font-bold uppercase tracking-[0.16em] text-acid mb-4 md:mb-6" data-id="element-86" data-mp="83m83rt0vkxx">
          Your season starts here
        </p>

        <h2 className="font-display uppercase text-white text-[8vw] min-[430px]:text-4xl md:text-6xl leading-[1.02] mb-5 md:mb-7" data-id="element-87" data-mp="h6dm9zda8ut9">
          Plan better. Coach better.{' '}
          <span className="text-acid" data-id="element-88" data-mp="qvoqb7lbb9aa">Win more games.</span>
        </h2>

        <p className="text-gray-300 text-sm md:text-lg italic max-w-xl mx-auto mb-8 md:mb-11" data-id="element-89" data-mp="qwglihazz501">
          "Because preparing a great session should not cost you every night of
          the week."
        </p>

        <button onClick={scrollToOffer} className="w-full sm:w-auto bg-neon hover:bg-neon-light text-ink font-display uppercase text-lg md:text-2xl tracking-wide px-10 md:px-12 py-5 md:py-6 rounded-xl shadow-[0_5px_0_0_var(--neon-deep)] active:translate-y-[3px] active:shadow-[0_2px_0_0_var(--neon-deep)] transition-all" data-id="element-90" data-mp="zua6iw3bac7w">
          Get Rugby 360 Now — $27
        </button>

        <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 mt-6 md:mt-8 text-[0.7rem] md:text-sm text-gray-400" data-id="element-91" data-mp="2qzujlq9wdi2p">
          <span className="flex items-center gap-1.5" data-id="element-92" data-mp="302c5g3ln48p6">
            <Lock className="text-acid" size={14} data-id="element-93" data-mp="300sn87gfbnkr" /> Secure payment
          </span>
          <span className="flex items-center gap-1.5" data-id="element-94" data-mp="34un1gvd9facg">
            <Zap className="text-acid" size={14} data-id="element-95" data-mp="39s5fv1a1qhru" /> Instant access
          </span>
          <span className="flex items-center gap-1.5" data-id="element-96" data-mp="39u9fh70wwumb">
            <ShieldCheck className="text-acid" size={14} data-id="element-97" data-mp="3est3dcz2gghb" /> 7-day guarantee
          </span>
        </div>
      </div>
    </section>;
}